import React from 'react';

export const CarouselArrow = ({ direction, onClick, className }) => {
    return (
        <button
            className={`carousel-arrow ${direction} ${className}`}
            onClick={onClick}
            aria-label={`${direction === 'prev' ? 'Previous' : 'Next'} slide`}
        >
            <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                {direction === 'prev' ? (
                    <path
                        d="M15 18L9 12L15 6"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                ) : (
                    <path
                        d="M9 6L15 12L9 18"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                )}
            </svg>
        </button>
    );
}; 